"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AirMixingToolContainerComponent = AirMixingToolContainerComponent;
const Actions = __importStar(require("./actions"));
const React = __importStar(require("react"));
const Elements = __importStar(require("@genesys/client-core/lib/elements"));
const GenesysPropertiesSelector = __importStar(require("@genesys/client-core/lib/genesys-properties-selector"));
const property_1 = require("@genesys/property");
const ResultComponent = __importStar(require("@genesys/client-core/lib/result-component"));
function AirMixingToolContainerComponent(props) {
    const onAirstream1Changed = (properties) => props.dispatch(Actions.setPropertiesAir1(properties));
    const onAirstream2Changed = (properties) => props.dispatch(Actions.setPropertiesAir2(properties));
    const onCalculateMix = () => props.dispatch(Actions.calculateMix());
    const air1Definition = humidityInputDefinition(property_1.PropertyValueSet.getAmount("temperature", props.airstream1), property_1.PropertyValueSet.getAmount("pressure", props.airstream1));
    const air2Definition = humidityInputDefinition(property_1.PropertyValueSet.getAmount("temperature", props.airstream2), property_1.PropertyValueSet.getAmount("pressure", props.airstream2));
    const mixProperties = [
        {
            sortNo: 1,
            propertyName: "temperature"
        },
        {
            sortNo: 2,
            propertyName: "humidity"
        },
        {
            sortNo: 3,
            propertyName: "pressure"
        },
        {
            sortNo: 4,
            propertyName: "flow"
        },
        {
            sortNo: 5,
            propertyName: "condensation"
        }
    ];
    return (React.createElement(Elements.FlexContainerRowWithPadding, { center: false },
        React.createElement(Elements.FlexContainerStack, null,
            React.createElement(Elements.InnerContainer, null,
                React.createElement(Elements.H3, null, "Air 1"),
                React.createElement(GenesysPropertiesSelector.PropertiesSelectorContainer, { selectedProperties: props.airstream1, productProperties: air1Definition, screenAmountProfileFieldGroup: "AirMixer", onChange: (properties) => onAirstream1Changed(properties), uniqueId: "airmixer_air1" })),
            React.createElement(Elements.InnerContainer, null,
                React.createElement(Elements.H3, null, "Air 2"),
                React.createElement(GenesysPropertiesSelector.PropertiesSelectorContainer, { selectedProperties: props.airstream2, productProperties: air2Definition, screenAmountProfileFieldGroup: "AirMixer", onChange: (properties) => onAirstream2Changed(properties), uniqueId: "airmixer_air2" }))),
        React.createElement(Elements.FlexContainerStack, { centerVertically: true },
            React.createElement("span", null,
                React.createElement(Elements.StandardButton, { onClick: () => onCalculateMix() }, "Calculate"))),
        React.createElement(Elements.FlexContainerStack, null,
            React.createElement(Elements.InnerContainer, null, props.error ? (React.createElement("div", null, props.error)) : (React.createElement(React.Fragment, null,
                React.createElement(Elements.H3, null, "Air out"),
                React.createElement(ResultComponent.Container, { fieldGroup: "AirMixer", properties: props.mixAirstream, propertyDefinitions: mixProperties })))))));
}
function humidityInputDefinition(temperature, pressure) {
    return [
        {
            sort_no: 1,
            name: "temperature",
            group: "",
            quantity: "Temperature",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 2,
            name: "humidity",
            group: "",
            quantity: "HumidityRatio",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            conversionParameters: {
                temperature: temperature,
                pressure: pressure
            },
            value: []
        },
        {
            sort_no: 3,
            name: "pressure",
            group: "",
            quantity: "Pressure",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 4,
            name: "flow",
            group: "",
            quantity: "MassFlow",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        }
    ];
}
//# sourceMappingURL=container-component.js.map